import { Component, OnInit, ViewEncapsulation } from '@angular/core';

export interface StatisticDataCard {
  svg: string;
  statistic: string;
  description: string;
}

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-statistical-highlights',
  styleUrls: ['./statistical-highlights.component.scss'],
  templateUrl: './statistical-highlights.component.html'
})
export class StatisticalHighlightsComponent implements OnInit {
  statisticDataCards: StatisticDataCard[] = [
    {
      description: 'Integrated Law Firms, Fund Administrators and Banks',
      statistic: '25+',
      svg: 'assets/icons/circle-square-v2.svg'
    },
    {
      description: 'Clients',
      statistic: '238+',
      svg: 'assets/icons/briefcase-v2.svg'
    },
    {
      description: 'LPs',
      statistic: '13,500+',
      svg: 'assets/icons/globe-two-v3.svg'
    },
    {
      description: 'in Assets Managed on Flow',
      statistic: '$9.6+ Billion',
      svg: 'assets/icons/chart-up-v2.svg'
    }
  ];

  constructor() {}

  ngOnInit(): void {}
}
